import { Scrollbars } from 'react-custom-scrollbars-2';

export default function CustomScrollbars({
  children,
  autoHeight = true,
  autoHide = false,
  autoHideTimeout = 1000,
  autoHideDuration = 200,
  thumbMinSize = 30,
  autoHeightMax = undefined,
}) {
  const renderThumbHorizontal = () => {
    return <div className="bg-gray-500 dark:bg-gray-400 h-1 rounded-md"></div>;
  };

  return (
    <Scrollbars
      autoHide={autoHide}
      autoHideTimeout={autoHideTimeout}
      autoHideDuration={autoHideDuration}
      autoHeight={autoHeight}
      thumbMinSize={thumbMinSize}
      autoHeightMax={autoHeightMax}
      universal
      renderThumbHorizontal={renderThumbHorizontal}
    >
      {children}
    </Scrollbars>
  );
}
